var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import style from './Button.module.scss';
export function HeaderPrimaryButton(_a) {
    var _b, _c, _d;
    var buttonClassName = _a.buttonClassName, outlined = _a.outlined, children = _a.children, href = _a.href, disableArrow = _a.disableArrow;
    return (_jsxs("button", __assign({ type: "button", className: clsx(style.menuButton, (_b = {}, _b[style.arrow] = !disableArrow, _b), (_c = {}, _c[style.primary] = !outlined, _c), (_d = {}, _d[style.outline] = outlined, _d), buttonClassName), onClick: href ? function () { return window.open(href); } : undefined }, { children: [children, !disableArrow && _jsx(FontAwesomeIcon, { className: style.buttonIcon, icon: faChevronRight })] })));
}
